import { useMutation } from '@tanstack/react-query'
import { api } from '@api'
import { resolveLanguage } from '@context'
import { secureTokenStore, useLanguageStore } from '@store'

interface Account {
  id: string
  email: string
  isOnboardingCompleted: boolean
}

export interface SignUpResponse {
  account: Account
  accessToken: string
  refreshToken: string
}

interface SignUpCredentials {
  email: string
  password: string
}

export const signUp = async (credentials: SignUpCredentials): Promise<SignUpResponse> => {
    // The language on screen, which the person may have picked on the welcome screen.
    const language = resolveLanguage(useLanguageStore.getState().language)
    const { data } = await api.post<SignUpResponse>('/v2/authentication/accounts', { ...credentials, language })

    if (data.accessToken && data.refreshToken) {
      await secureTokenStore.setTokens(data.accessToken, data.refreshToken)
    }

    const { password: _password, ...sanitizedAccount } = data.account as Account & { password?: string }

    return {
      ...data,
      account: sanitizedAccount,
    }
}

export const useSignUp = () => {
  return useMutation<SignUpResponse, Error, SignUpCredentials>({
    mutationFn: signUp,
  })
}
